var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBounce({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1589_812)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.25C14.5858 5.25 14.25 5.58579 14.25 6C14.25 6.41421 14.5858 6.75 15 6.75H17.9729C15.5108 8.31468 13.6475 10.6856 12.7165 13.478L12.7165 13.478L12.4025 14.4202C11.9587 12.8029 11.101 11.3125 9.89429 10.1059C8.06581 8.27739 5.58586 7.25016 3 7.25016C2.58579 7.25016 2.25 7.58595 2.25 8.00016C2.25 8.41438 2.58579 8.75016 3 8.75016C5.18804 8.75016 7.28646 9.61936 8.83363 11.1665C10.3808 12.7137 11.25 14.8121 11.25 17.0002V17.25H10C9.58579 17.25 9.25 17.5858 9.25 18C9.25 18.4142 9.58579 18.75 10 18.75H11.9819C11.9943 18.7503 12.0068 18.7503 12.0191 18.75H14C14.4142 18.75 14.75 18.4142 14.75 18C14.75 17.5858 14.4142 17.25 14 17.25H13.0405L14.1395 13.9524C15.0195 11.3129 16.8437 9.10018 19.25 7.73166V11C19.25 11.4142 19.5858 11.75 20 11.75C20.4142 11.75 20.75 11.4142 20.75 11V6.51524C20.7502 6.50482 20.7502 6.49438 20.75 6.48393V6C20.75 5.58579 20.4142 5.25 20 5.25H15Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1589_812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBounce);
export default __webpack_public_path__ + "static/media/Bounce.116cf3df25142134a59113a35f8c3531.svg";
export { ForwardRef as ReactComponent };